module.exports = __webpack_public_path__ + "3bffed22b3ece330d9e1e74aa935a2fe.MP3";